// extracted by mini-css-extract-plugin
module.exports = {"root":"tabs-trigger-trailing_root__UTngq"};